import validate from "/app/node_modules/.pnpm/nuxt@4.1.2_@biomejs+biome@2.2.2_@capacitor+preferences@7.0.2_@capacitor+core@7.3.0__@pa_6f92e3d1a35919dae73eb08ec212fd14/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects301_45global from "/app/apps/website/app/middleware/redirects301.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.1.2_@biomejs+biome@2.2.2_@capacitor+preferences@7.0.2_@capacitor+core@7.3.0__@pa_6f92e3d1a35919dae73eb08ec212fd14/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects301_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}